import { useMemo } from "react";
import { useSelector } from "react-redux";
import type { RoomInfoProducts } from "@b2bportal/lodging-api";
import { PackageHotelShopSelectors } from "@/store/packages";

/**
 * Re-sorts rooms by package incremental change price instead of hotel tripTotal.
 * Falls back to tripTotal when package pricing is unavailable.
 */
export const usePackageRoomSort = (
  rooms: RoomInfoProducts[] | undefined
): RoomInfoProducts[] | undefined => {
  const packagesByRateId = useSelector(
    PackageHotelShopSelectors.getPackagesByRateId
  );

  return useMemo(() => {
    if (!rooms) return rooms;

    return [...rooms].sort((a, b) => {
      const rateIdA = a.products?.[0]?.rateId?.value;
      const rateIdB = b.products?.[0]?.rateId?.value;

      const priceA =
        (rateIdA
          ? packagesByRateId?.[rateIdA]?.price?.incrementalChange?.fiat?.value
          : undefined) ??
        a.products?.[0]?.tripTotal?.fiat?.value ??
        0;
      const priceB =
        (rateIdB
          ? packagesByRateId?.[rateIdB]?.price?.incrementalChange?.fiat?.value
          : undefined) ??
        b.products?.[0]?.tripTotal?.fiat?.value ??
        0;

      return priceA - priceB;
    });
  }, [rooms, packagesByRateId]);
};
